import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { CheckAccessDataService } from 'src/shared/services/checkaccess.data.service/checkaccess.data.service';
import { BannerComponent } from '../../design/banner/banner.component';
import { PageWrapperComponent } from '../../design/pagewrapper/pagewrapper.component';
import { TitleComponent } from '../../design/title/title.component';

@Component({
  selector: 'app-checkstaffaccess',
  templateUrl: './checkstaffaccess.component.html',
  imports: [PageWrapperComponent, TitleComponent, BannerComponent],
})
export class CheckStaffAccessComponent implements OnInit {
  private router = inject(Router);
  private checkAccessDataService = inject(CheckAccessDataService);

  needsAnAccount: boolean = false;
  loading: boolean = false;
  error = '';
  hasAccess = false;

  ngOnInit(): void {
    this.checkStaff();
  }

  checkStaff() {
    this.error = '';
    if (this.loading) return;
    this.loading = true;
    this.checkAccessDataService
      .GetStaff()
      .then(() => this.alreadyHasAccount())
      .catch((error) => this.handleStaffCheckError(error))
      .finally(() => {
        if (!this.hasAccess) {
          this.finally();
        }
      });
  }

  handleStaffCheckError(error: any) {
    if (error?.code === 'failed_precondition') {
      this.createStaff();
    } else {
      this.unknownError();
    }
  }

  createStaff() {
    this.checkAccessDataService
      .CreateStaff({})
      .then(() => this.alreadyHasAccount())
      .catch((error) => this.handleStaffCreateError(error))
      .finally(() => {
        if (!this.hasAccess) {
          this.finally();
        }
      });
  }

  handleStaffCreateError(error: any) {
    this.error = error.message ?? 'Unknown staff creation error';
  }

  unknownError() {
    this.error = 'An unknown error occured validating your staff account.';
  }

  alreadyHasAccount() {
    this.hasAccess = true;
    this.complete();
  }

  complete() {
    if (environment.app === 'PMS' && !this.checkAccessDataService.hasRole('clinician')) {
      void this.router.navigate(['/not-clinician']).then(() => this.finally());
      return;
    }
    void this.router.navigate(['/onboarding']).then(() => this.finally());
  }

  finally() {
    this.loading = false;
  }

  clearError() {
    this.error = '';
  }
}
